const { axiosDefault, handleErrors } = require('../utils/defaults');

const sellerService = {
  admin: {
    getList: async () => {
      try {
        const axios = axiosDefault();
        const { data } = await axios.get(`/api/seller/admin`);
        return data;
      } catch (error) {
        return handleErrors(error);
      }
    },
  },
};

export default sellerService;
